import { ShoppingBag, ShoppingBasketIcon, ShoppingCartIcon, Trash2Icon } from 'lucide-react'
import React from 'react'
import { Badge, Button, Card, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const LabCard = ({lab, addToCart,updateQuantity, quantity, carted}) => {
    const handleCartClick = () => {

        addToCart(lab,carted);

        // setCarted(!carted);
    }

    const handleIncrease = () => {
        updateQuantity(lab.id, quantity + 1);
    };

    const handleDecrease = () => {
        if (quantity > 1) {
            updateQuantity(lab.id, quantity - 1);
        }
    };

    console.log(lab, 'lab')
    return (
        <Col onClick={handleCartClick} style={{cursor:'pointer'}} sm="4" md='3' className='mb-2'>
            <Card className="card-event">

                
                {/* <Link to="#"><img src='' className="card-img-top" alt="" /></Link> */}
                <Card.Body className='d-flex align-items-center gap-2 p-2'>
                    <div className="avatar">
                        <span className={"avatar-initial fs-sm bg-primary"}>
                            <i className="ri-shopping-cart-line"></i>
                        </span>
                    </div>
                    <div className='d-flex flex-column align-items-start w-100'>
                        <h6><Link to="" className='fs-sm'>{lab?.name}</Link></h6>
                        <p className="text-secondary fs-sm m-0">{lab?.labTest?.category?.name}</p>
                        {/* <p className="text-secondary fs-sm m-0">Dr. {lab.createdBy}</p> */}

                    </div>
                </Card.Body>
                <div className="divider divider-start fw-medium m-0"></div>
                <Card.Footer onClick={(e)=>e.stopPropagation()} className='d-flex justify-content-between p-2'>

                    <span className='fs-sm'>&#8358;{lab?.serviceCost?.tariff.toLocaleString()}</span>

                    <div className='d-flex gap-2 align-items-center'>
                        {carted ? (
                            <>
                                {/* <Button size="sm" variant="outline-secondary" onClick={handleDecrease}>-</Button>
                                <span>{quantity}</span>
                                <Button size="sm" variant="outline-secondary" onClick={handleIncrease}>+</Button> */}
                                <Badge style={{ cursor: "pointer" }} bg="" className=' text-danger' onClick={handleCartClick}><Trash2Icon className='text-sm'/></Badge>
                            </>
                        ) : (
                            <Badge style={{ cursor: "pointer" }} bg="" className=' text-success' onClick={handleCartClick}><ShoppingCartIcon/></Badge>
                        )}
                    </div>
                    

                </Card.Footer>
            </Card>
        </Col>
    )
}

export default LabCard